import * as React from 'react';
import { RenderHtml } from '../../../utils';
export class MarkdownComponent extends React.PureComponent {
    render() {
        const maybeRenderedHtml = this.props.value.renderedHtml;
        return (React.createElement("div", { className: 'component markdown-component', "data-component-type": 'markdown' },
            React.createElement(RenderHtml, { html: maybeRenderedHtml, className: 'rendered-html' })));
    }
}
